export const StickerTypes = {
  INDEX: "sticker_index",
  DETAILS: "sticker_detail"
};
